import React from 'react';
import '../css/Footer.css';

const Footer = () => (
  <div className="footer"/>
);

export default Footer;
